import React from "react";
import {
	FaBold,
	FaItalic,
	FaUnderline,
	FaStrikethrough,
	FaTextWidth,
	FaLink,
	FaImage,
	FaListUl,
	FaListOl,
	FaCode,
	FaChevronUp,
	FaChevronDown,
	FaAlignLeft,
	FaAlignCenter,
	FaAlignRight,
} from "react-icons/fa";
import { RichUtils, AtomicBlockUtils, EditorState } from "draft-js";

const Toolbar = ({ editorState, setEditorState }) => {
	const tools = [
		{
			label: "bold",
			style: "BOLD",
			icon: <FaBold />,
			method: "inline",
		},
		{
			label: "italic",
			style: "ITALIC",
			icon: <FaItalic />,
			method: "inline",
		},
		{
			label: "underline",
			style: "UNDERLINE",
			icon: <FaUnderline />,
			method: "inline",
		},
		{
			label: "strike-through",
			style: "STRIKETHROUGH",
			icon: <FaStrikethrough />,
			method: "inline",
		},
		{
			label: "Monospace",
			style: "CODE",
			icon: <FaTextWidth />,
			method: "inline",
		},
		{
			label: "Unordered-List",
			style: "unordered-list-item",
			method: "block",
			icon: <FaListUl />,
		},
		{
			label: "Ordered-List",
			style: "ordered-list-item",
			method: "block",
			icon: <FaListOl />,
		},
		{
			label: "Code Block",
			style: "CODEBLOCK",
			icon: <FaCode />,
			method: "inline",
		},
		{
			label: "Uppercase",
			style: "UPPERCASE",
			icon: <FaChevronUp />,
			method: "inline",
		},
		{
			label: "lowercase",
			style: "LOWERCASE",
			icon: <FaChevronDown />,
			method: "inline",
		},
		{
			label: "Left",
			style: "leftAlign",
			icon: <FaAlignLeft />,
			method: "block",
		},
		{
			label: "Center",
			style: "centerAlign",
			icon: <FaAlignCenter />,
			method: "block",
		},
		{
			label: "Right",
			style: "rightAlign",
			icon: <FaAlignRight />,
			method: "block",
		},
		{
			label: "Add Link",
			action: "addLink",
			icon: <FaLink />,
		},
		{
			label: "Add Image",
			action: "addImage",
			icon: <FaImage />,
		},
		{ label: "H1", style: "header-one", method: "block" },
		{ label: "H2", style: "header-two", method: "block" },
		{ label: "H3", style: "header-three", method: "block" },
		{ label: "H4", style: "header-four", method: "block" },
		{ label: "H5", style: "header-five", method: "block" },
		{ label: "H6", style: "header-six", method: "block" },
	];

	const handleAction = (action) => {
		if (action === "addImage") {
			const url = prompt("Inserisci l'URL dell'immagine:");
			if (!url) return;

			const contentState = editorState.getCurrentContent();
			const contentStateWithEntity = contentState.createEntity("IMAGE", "IMMUTABLE", {
				src: url,
			});
			const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

			const newEditorState = AtomicBlockUtils.insertAtomicBlock(
				EditorState.set(editorState, { currentContent: contentStateWithEntity }),
				entityKey,
				" "
			);

			setEditorState(newEditorState);
		} else if (action === "addLink") {
			const selection = editorState.getSelection();
			if (selection.isCollapsed()) {
				alert("Seleziona il testo da collegare.");
				return;
			}

			const url = prompt("Inserisci l'URL del link:");
			if (!url) return;

			const contentState = editorState.getCurrentContent();
			const contentStateWithEntity = contentState.createEntity("LINK", "MUTABLE", { url });
			const entityKey = contentStateWithEntity.getLastCreatedEntityKey();

			const newEditorState = RichUtils.toggleLink(editorState, selection, entityKey);
			setEditorState(newEditorState);
		}
	};

	const applyStyle = (e, style, method) => {
		e.preventDefault();
		method === "block"
			? setEditorState(RichUtils.toggleBlockType(editorState, style))
			: setEditorState(RichUtils.toggleInlineStyle(editorState, style));
	};

	const isActive = (style, method) => {
		if (method === "block") {
			const selection = editorState.getSelection();
			const blockType = editorState
				.getCurrentContent()
				.getBlockForKey(selection.getStartKey())
				.getType();
			return blockType === style;
		} else {
			const currentStyle = editorState.getCurrentInlineStyle();
			return currentStyle.has(style);
		}
	};

	return (
		<div className="flex flex-wrap">
			{tools.map((item, idx) => (
				<button
					id="tool"
					aria-label="tool"
					className="mr-2 text-base p-2 bg-white cursor-pointer"
					style={{
						color: isActive(item.style, item.method)
							? "rgba(0, 0, 0, 1)"
							: "rgba(0, 0, 0, 0.3)",
					}}
					key={`${item.label}-${idx}`}
					title={item.label}
					onClick={(e) => {
						if (item.action) {
							e.preventDefault();
							handleAction(item.action);
						} else {
							applyStyle(e, item.style, item.method);
						}
					}}
					onMouseDown={(e) => e.preventDefault()}
				>
					{item.icon || item.label}
				</button>
			))}
		</div>
	);
};

export default Toolbar;
